
import {defineComponent} from "vue";
import Dashboard from "../components/Dashboard.vue";
export default defineComponent({
    components: {
        Dashboard
    }
})
